"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GO_RETRO_SPRINT_REVIEW_NOTIFIER_CRON_TIMER = void 0;
exports.GO_RETRO_SPRINT_REVIEW_NOTIFIER_CRON_TIMER = `*/15 * * * *`;
//# sourceMappingURL=go-retro-sprint-notifier.js.map